/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a lump-sum investment?`)
};

const es_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es una inversión de suma única?`)
};

const de_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine Pauschalanlage?`)
};

const nl_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een eenmalige belegging?`)
};

const fr_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'un investissement versement unique ?`)
};

const it_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è un investimento forfettario?`)
};

const pt_br2_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um investimento único?`)
};

const pt_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é um investimento em montante único?`)
};

const ja_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括投資とは何ですか？`)
};

const zh_sip_lumpsum_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是一次性投资？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_faq1_q", locale)
	if (locale === "en") return en_sip_lumpsum_faq1_q(inputs)
	if (locale === "es") return es_sip_lumpsum_faq1_q(inputs)
	if (locale === "de") return de_sip_lumpsum_faq1_q(inputs)
	if (locale === "nl") return nl_sip_lumpsum_faq1_q(inputs)
	if (locale === "fr") return fr_sip_lumpsum_faq1_q(inputs)
	if (locale === "it") return it_sip_lumpsum_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_faq1_q(inputs)
	if (locale === "pt") return pt_sip_lumpsum_faq1_q(inputs)
	if (locale === "ja") return ja_sip_lumpsum_faq1_q(inputs)
	return zh_sip_lumpsum_faq1_q(inputs)
};